/* APP REDUCER */
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_LOADING = "SET_LOADING";
export const SET_WINDOW_STATUS = "SET_WINDOW_STATUS";
export const SET_COOKIE_ACCEPTED = "SET_COOKIE_ACCEPTED";
export const SET_SCROLL_DISABLED = "SET_SCROLL_DISABLED";